import Multiselect from '../multiselect/Multiselect';

export default Multiselect;
